export const REMEMBERED_CREDENTIALS_KEY = "credentials"

const AUTH_STORAGE_KEYS = ["auth", "user", "company"] as const

export const clearRememberedCredentials = () => {
	sessionStorage.removeItem(REMEMBERED_CREDENTIALS_KEY)
}

export const clearAuthStorage = () => {
	for (const key of AUTH_STORAGE_KEYS) localStorage.removeItem(key)
	clearRememberedCredentials()
}
